// pages/public/Servicios.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bus, DollarSign, Smartphone, ChevronDown, ChevronUp, ArrowRight, Calendar, MapPin, Wifi, Wind, X, Search, Briefcase } from 'lucide-react';
import PublicLayout from '../../layouts/PublicLayout';
import { serviciosAPI } from '../../services/api';
import { showSuccess, showError, showLoading, dismissToast } from '../../utils/toast';

const ciudades = [
  { id: 1, nombre: "Ciudad Bolívar", estado: "Bolívar" },
  { id: 2, nombre: "Puerto Ordaz", estado: "Bolívar" },
  { id: 3, nombre: "San Félix", estado: "Bolívar" },
  { id: 4, nombre: "Upata", estado: "Bolívar" },
  { id: 5, nombre: "Guasipati", estado: "Bolívar" },
  { id: 6, nombre: "El Callao", estado: "Bolívar" },
  { id: 7, nombre: "Tumeremo", estado: "Bolívar" },
  { id: 8, nombre: "Santa Elena de Uairén", estado: "Bolívar" },
  { id: 9, nombre: "Kavak", estado: "Bolívar" },
  { id: 10, nombre: "San Ignacio de Yuruaní", estado: "Bolívar" },
  { id: 11, nombre: "El Paují", estado: "Bolívar" },
  { id: 12, nombre: "Ciudad Guayana", estado: "Bolívar" },
  { id: 13, nombre: "Maturín", estado: "Monagas" },
  { id: 14, nombre: "El Tigre", estado: "Anzoátegui" },
  { id: 15, nombre: "San Tomé", estado: "Anzoátegui" },
  { id: 16, nombre: "Cantaura", estado: "Anzoátegui" },
  { id: 17, nombre: "Anaco", estado: "Anzoátegui" },
  { id: 18, nombre: "Barcelona", estado: "Anzoátegui" },
  { id: 19, nombre: "Puerto La Cruz", estado: "Anzoátegui" },
  { id: 20, nombre: "Lechería", estado: "Anzoátegui" },
  { id: 21, nombre: "Cumaná", estado: "Sucre" },
  { id: 22, nombre: "Carúpano", estado: "Sucre" },
  { id: 23, nombre: "Porlamar", estado: "Nueva Esparta" },
  { id: 24, nombre: "La Asunción", estado: "Nueva Esparta" },
  { id: 25, nombre: "Caracas", estado: "Distrito Capital" },
  { id: 26, nombre: "Maracay", estado: "Aragua" },
  { id: 27, nombre: "Valencia", estado: "Carabobo" },
  { id: 28, nombre: "Barquisimeto", estado: "Lara" },
  { id: 29, nombre: "Maracaibo", estado: "Zulia" },
  { id: 30, nombre: "Boa vista", estado: "Roraima - Brasil" },
  { id: 31, nombre: "Manaos", estado: "Amazonas - Brasil" }

];

const formatFechaDisplay = (fecha) => {
  if (!fecha) return '';
  return fecha.split('T')[0];
};

const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// ✅ Función para formatear fecha corta (dd/mm)
const formatearFechaCorta = (fecha) => {
  if (!fecha) return '';
  const dateStr = fecha.split('T')[0];
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}`;
};

// ✅ Función para verificar si la fecha de llegada es diferente a la de salida
const esDiaSiguiente = (fechaSalida, fechaLlegada) => {
  if (!fechaSalida || !fechaLlegada) return false;
  const salida = fechaSalida.split('T')[0];
  const llegada = fechaLlegada.split('T')[0];
  return salida !== llegada;
};

const Servicios = () => {
  const navigate = useNavigate();
  const [servicios, setServicios] = useState([]);
  const [fechasDisponibles, setFechasDisponibles] = useState([]);
  const [selectedDateIndex, setSelectedDateIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [orden, setOrden] = useState("masTemprano");
  const [busquedaData, setBusquedaData] = useState(null);
  
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({
    origen: '',
    destino: '',
    fechaIda: '',
    pasajeros: 1
  });
  
  const [origenSugerencias, setOrigenSugerencias] = useState([]);
  const [destinoSugerencias, setDestinoSugerencias] = useState([]);
  const [showOrigenSugerencias, setShowOrigenSugerencias] = useState(false);
  const [showDestinoSugerencias, setShowDestinoSugerencias] = useState(false);

  const filtrarCiudades = (texto) => {
    if (!texto) return [];
    return ciudades
      .filter(ciudad => 
        ciudad.nombre.toLowerCase().includes(texto.toLowerCase()) ||
        ciudad.estado.toLowerCase().includes(texto.toLowerCase())
      )
      .slice(0, 8);
  };

  const handleOrigenChange = (e) => {
    const value = e.target.value;
    setEditFormData({...editFormData, origen: value});
    setOrigenSugerencias(filtrarCiudades(value));
    setShowOrigenSugerencias(value.length > 0);
  };

  const handleDestinoChange = (e) => {
    const value = e.target.value;
    setEditFormData({...editFormData, destino: value});
    setDestinoSugerencias(filtrarCiudades(value));
    setShowDestinoSugerencias(value.length > 0);
  };

  const seleccionarOrigen = (ciudad) => {
    setEditFormData({...editFormData, origen: ciudad.nombre});
    setShowOrigenSugerencias(false);
  };

  const seleccionarDestino = (ciudad) => {
    setEditFormData({...editFormData, destino: ciudad.nombre});
    setShowDestinoSugerencias(false);
  };

  const esFechaFutura = (fecha) => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaComparar = new Date(fecha);
    fechaComparar.setHours(0, 0, 0, 0);
    return fechaComparar >= hoy;
  };

  useEffect(() => {
    const savedData = localStorage.getItem('busquedaData');
    if (savedData) {
      const data = JSON.parse(savedData);
      setBusquedaData(data);
      setEditFormData({
        origen: data.origen || '',
        destino: data.destino || '',
        fechaIda: formatFechaDisplay(data.fechaIda) || '',
        pasajeros: data.pasajeros || 1
      });
      cargarDatos(data);
    } else {
      setLoading(false);
    }
  }, []);

  const cargarDatos = async (filtros) => {
    setLoading(true);
    try {
      await cargarServicios(filtros, filtros.fechaIda);
      await cargarFechasDisponibles(filtros);
    } catch (error) {
      console.error('Error al cargar datos:', error);
      showError('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const cargarServicios = async (filtros, fecha) => {
    try {
      const data = await serviciosAPI.buscar(filtros.origen, filtros.destino, fecha);
      
      const serviciosFormateados = data.map(servicio => {
        // ✅ El backend ya devuelve la duración formateada (ej: "1d 2h 2m")
        const duracionTotal = servicio.duracion;
        const horaSalida = servicio.horaSalida ? servicio.horaSalida.substring(0, 5) : '';
        const horaLlegada = servicio.horaLlegada ? servicio.horaLlegada.substring(0, 5) : '';
        
        // ✅ Determinar si la llegada es al día siguiente
        const esDiaSiguienteFlag = esDiaSiguiente(servicio.fecha, servicio.fechaLlegada);
        
        return {
          id: servicio.id,
          horario: {
            salida: horaSalida,
            llegada: horaLlegada,
            duracion: duracionTotal,
            origen: servicio.origen,
            destino: servicio.destino,
            fechaSalida: servicio.fecha,
            fechaLlegada: servicio.fechaLlegada,
            esDiaSiguiente: esDiaSiguienteFlag
          },
          precio: servicio.precio,
          formasPago: ["efectivo", "transferencia"],
          fecha: servicio.fecha,
          tipo: servicio.tipo || 'Directo',
          tramos: servicio.tramos || [],
          busquedaOrigen: filtros.origen,
          busquedaDestino: filtros.destino
        };
      });
      
      setServicios(serviciosFormateados);
    } catch (error) {
      console.error('Error al cargar servicios:', error);
      showError('Error al cargar los servicios');
    }
  };

  const cargarFechasDisponibles = async (filtros) => {
    try {
      const data = await serviciosAPI.getFechasDisponibles(filtros.origen, filtros.destino);
      const fechasFuturas = data.filter(item => esFechaFutura(item.fecha));
      
      const fechasFormateadas = fechasFuturas.map(item => ({
        fecha: item.fecha,
        dia: new Date(item.fecha).toLocaleDateString('es', { weekday: 'short' }),
        diaNumero: new Date(item.fecha).getDate(),
        mes: new Date(item.fecha).toLocaleDateString('es', { month: 'short' }),
        precioMinimo: item.precioMinimo,
        tieneServicios: item.cantidad > 0
      }));
      
      setFechasDisponibles(fechasFormateadas);
      
      const index = fechasFormateadas.findIndex(f => f.fecha === filtros.fechaIda);
      if (index !== -1) {
        setSelectedDateIndex(index);
      } else {
        setSelectedDateIndex(null);
      }
    } catch (error) {
      console.error('Error al cargar fechas:', error);
    }
  };

  const handleDateChange = async (index) => {
    setSelectedDateIndex(index);
    setLoading(true);
    
    const fechaSeleccionada = fechasDisponibles[index];
    if (fechaSeleccionada && busquedaData) {
      const newBusquedaData = {
        ...busquedaData,
        fechaIda: fechaSeleccionada.fecha
      };
      setBusquedaData(newBusquedaData);
      localStorage.setItem('busquedaData', JSON.stringify(newBusquedaData));
      await cargarServicios(newBusquedaData, fechaSeleccionada.fecha);
    }
    
    setLoading(false);
  };

  const handleEditSearch = () => {
    setShowEditModal(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    
    const newBusquedaData = {
      origen: editFormData.origen,
      destino: editFormData.destino,
      fechaIda: editFormData.fechaIda,
      pasajeros: editFormData.pasajeros
    };
    
    setBusquedaData(newBusquedaData);
    localStorage.setItem('busquedaData', JSON.stringify(newBusquedaData));
    setShowEditModal(false);
    cargarDatos(newBusquedaData);
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const formatPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR').format(precio);
  };

  const handleComprar = (servicio) => {
    const cantidad = busquedaData?.pasajeros || 1;
    
    const tramoIds = servicio.tipo === 'Por Tramos' 
      ? servicio.tramos.map(t => t.id) 
      : [];
    
    navigate('/compra', { 
      state: { 
        servicio: servicio,
        cantidadPasajeros: cantidad,
        tramoIds: tramoIds
      } 
    });
  };

  const serviciosOrdenados = [...servicios].sort((a, b) => {
    switch (orden) {
      case 'masTemprano':
        return a.horario.salida.localeCompare(b.horario.salida);
      case 'masTarde':
        return b.horario.salida.localeCompare(a.horario.salida);
      case 'menorPrecio':
        return a.precio - b.precio;
      case 'mayorPrecio':
        return b.precio - a.precio;
      default:
        return 0;
    }
  });

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {busquedaData && (
          <div className="mb-8 bg-white border-2 border-[#e83e8c] rounded-2xl shadow-lg overflow-hidden">
            <div className="p-6">
              <div className="flex flex-wrap gap-6 justify-between items-center">
                <div className="flex flex-wrap gap-6">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-pink-50 rounded-xl">
                      <MapPin className="w-4 h-4 text-[#e83e8c]" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 uppercase tracking-wide">Origen</div>
                      <div className="font-medium text-gray-800">{busquedaData.origen || 'No especificado'}</div>
                    </div>
                  </div>
                  <div className="text-gray-300 text-xl">→</div>
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-pink-50 rounded-xl">
                      <MapPin className="w-4 h-4 text-[#e83e8c]" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 uppercase tracking-wide">Destino</div>
                      <div className="font-medium text-gray-800">{busquedaData.destino || 'No especificado'}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-pink-50 rounded-xl">
                      <Calendar className="w-4 h-4 text-[#e83e8c]" />
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 uppercase tracking-wide">Fecha</div>
                      <div className="font-medium text-gray-800">{formatFechaDisplay(busquedaData.fechaIda) || 'No especificada'}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-pink-50 rounded-xl">
                      <svg className="w-4 h-4 text-[#e83e8c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 uppercase tracking-wide">Pasajeros</div>
                      <div className="font-medium text-gray-800">{busquedaData.pasajeros} {busquedaData.pasajeros === 1 ? 'persona' : 'personas'}</div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-3">
                  <button 
                    onClick={handleEditSearch}
                    className="text-sm text-[#e83e8c] hover:text-[#c2185b] underline transition-colors"
                  >
                    Editar búsqueda
                  </button>
                  <button 
                    onClick={() => navigate('/')}
                    className="text-sm text-[#e83e8c] hover:text-[#c2185b] underline transition-colors"
                  >
                    Nueva búsqueda
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="mb-10">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
              Próximas fechas disponibles
            </h3>            
          </div>
          <div className="relative">
            <div className="overflow-x-auto pb-4 scrollbar-thin">
              <div className="flex gap-4 min-w-max px-2">
                {fechasDisponibles.length === 0 ? (
                  <div className="text-gray-400 text-sm py-4">No hay fechas disponibles</div>
                ) : (
                  fechasDisponibles.map((fecha, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleDateChange(idx)}
                      className={`flex-shrink-0 w-28 text-center py-4 px-2 transition-all duration-300 rounded-2xl ${
                        selectedDateIndex === idx
                          ? 'bg-[#e83e8c] text-white shadow-xl scale-105'
                          : 'bg-white text-gray-700 border border-gray-100 hover:border-[#e83e8c] hover:shadow-md hover:-translate-y-1'
                      }`}
                    >
                      <div className={`text-xs font-medium ${selectedDateIndex === idx ? 'text-white/80' : 'text-gray-500'}`}>
                        {fecha.dia}
                      </div>
                      <div className={`text-xl font-bold mt-2 ${selectedDateIndex === idx ? 'text-white' : 'text-gray-800'}`}>
                        {fecha.diaNumero}
                      </div>
                      <div className={`text-xs ${selectedDateIndex === idx ? 'text-white/80' : 'text-gray-400'}`}>
                        {fecha.mes}
                      </div>
                      <div className="text-xs mt-3 pt-2 border-t border-white/20">
                        desde
                      </div>
                      <div className={`text-base font-bold mt-1 ${selectedDateIndex === idx ? 'text-white' : 'text-gray-800'}`}>
                        ${formatPrecio(fecha.precioMinimo)}
                      </div>
                    </button>
                  ))
                )}
              </div>
            </div>
          </div>
          {selectedDateIndex === null && fechasDisponibles.length > 0 && (
            <p className="text-xs text-gray-400 text-center mt-2">
              Seleccioná una fecha para ver los horarios disponibles
            </p>
          )}
        </div>

        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          <div className="text-sm text-gray-500 bg-pink-50 px-4 py-2 rounded-full shadow-sm border border-[#e83e8c]/20">
            {servicios.length} servicios disponibles
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500">Ordenar por:</span>
            <select
              value={orden}
              onChange={(e) => setOrden(e.target.value)}
              className="px-5 py-2 border border-gray-200 rounded-full focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none text-sm bg-white cursor-pointer hover:border-[#e83e8c] transition-all shadow-sm"
            >
              <option value="masTemprano">Más temprano</option>
              <option value="masTarde">Más tarde</option>
              <option value="menorPrecio">Menor precio</option>
              <option value="mayorPrecio">Mayor precio</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-16 bg-white rounded-2xl shadow-sm">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#e83e8c] mx-auto"></div>
            <p className="text-gray-500 mt-4">Cargando servicios...</p>
          </div>
        ) : serviciosOrdenados.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-2xl shadow-sm">
            <Bus className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-medium text-gray-600">No hay servicios disponibles</h3>
            <p className="text-gray-400 text-sm mt-2">intenta con otra fecha o destino</p>
            <button 
              onClick={() => navigate('/')}
              className="mt-4 text-[#e83e8c] underline hover:text-[#c2185b]"
            >
              Modificar búsqueda
            </button>
          </div>
        ) : (
          <div className="space-y-5">
            {serviciosOrdenados.map((servicio) => (
              <div
                key={servicio.id}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-[#e83e8c]"
              >
                <div className="p-6">
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
                    <div className="lg:col-span-6">
                      <div className="flex items-center justify-between">
                        <div className="text-center flex-1">
                          <div className="text-xs text-gray-400 uppercase tracking-wider">Salida</div>
                          <div className="text-3xl font-bold text-gray-800 mt-2">
                            {servicio.horario.salida}
                          </div>
                          <div className="text-sm text-gray-500 mt-1">
                            {servicio.tipo === 'Por Tramos' ? servicio.busquedaOrigen : servicio.horario.origen}
                          </div>
                        </div>
                        <div className="flex-1 text-center px-4">
                          <div className="text-xs text-gray-400 bg-pink-50 px-3 py-1 rounded-full inline-block border border-[#e83e8c]/20">
                            {servicio.horario.duracion}
                          </div>
                          <div className="relative my-3">
                            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-2">
                              <Bus className="w-4 h-4 text-[#e83e8c]" />
                            </div>
                          </div>
                        </div>
                        <div className="text-center flex-1">
                          <div className="text-xs text-gray-400 uppercase tracking-wider">
                            Llegada
                            {servicio.horario.esDiaSiguiente && (
                              <span className="ml-1 text-[#e83e8c] font-bold">
                                (+1 día)
                              </span>
                            )}
                          </div>
                          <div className="text-3xl font-bold text-gray-800 mt-2">
                            {servicio.horario.llegada}
                          </div>
                          <div className="text-sm text-gray-500 mt-1">
                            {servicio.tipo === 'Por Tramos' ? servicio.busquedaDestino : servicio.horario.destino}
                          </div>
                          {servicio.horario.esDiaSiguiente && servicio.horario.fechaLlegada && (
                            <div className="text-xs text-[#e83e8c] font-medium mt-1">
                              {formatearFechaCorta(servicio.horario.fechaLlegada)}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="lg:col-span-2">
                      {/* Espacio vacío intencional */}
                    </div>

                    <div className="lg:col-span-4">
                      <div className="flex items-center justify-between gap-4">
                        <div className="text-right">
                          <div className="text-3xl font-bold text-[#e83e8c]">${formatPrecio(servicio.precio)}</div>
                          <div className="text-xs text-gray-400 mt-1">por persona</div>
                        </div>
                        <button
                          onClick={() => toggleExpand(servicio.id)}
                          className="group bg-[#e83e8c] hover:bg-[#c2185b] text-white px-6 py-3 rounded-xl text-sm font-medium flex items-center gap-2 transition-all duration-300 hover:gap-3 shadow-md hover:shadow-lg"
                        >
                          {expandedId === servicio.id ? (
                            <><ChevronUp className="w-4 h-4" /> Ver menos</>
                          ) : (
                            <><ChevronDown className="w-4 h-4" /> Ver detalles</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {expandedId === servicio.id && (
                  <div className="border-t border-gray-100 bg-pink-50/30 p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-4">Métodos de pago</div>
                        <div className="flex gap-5">
                          <div className="text-center">
                            <DollarSign className="w-6 h-6 text-[#e83e8c]" />
                            <div className="text-xs text-gray-500 mt-2">Efectivo</div>
                          </div>
                          <div className="text-center">
                            <Smartphone className="w-6 h-6 text-[#e83e8c]" />
                            <div className="text-xs text-gray-500 mt-2">Transferencia</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-4">Servicios incluidos</div>
                        <div className="space-y-2">
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <Wind className="w-4 h-4 text-[#e83e8c]" /> Aire acondicionado
                          </div>
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <Wifi className="w-4 h-4 text-[#e83e8c]" /> WiFi gratuito
                          </div>
                          {/* ✅ NUEVO: Equipaje incluido */}
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <Briefcase className="w-4 h-4 text-[#e83e8c]" /> Equipaje: 1 maleta de 23kg (por persona)
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ✅ DETALLE DE TRAMOS */}
                    {servicio.tipo === 'Por Tramos' && servicio.tramos && servicio.tramos.length > 0 && (
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <h4 className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-3">
                          Detalle de los tramos
                        </h4>
                        <div className="space-y-2">
                          {servicio.tramos.map((tramo, i) => (
                            <div key={i} className="flex items-center justify-between p-2 bg-white rounded-lg border border-gray-200">
                              <div className="flex items-center gap-3 flex-wrap">
                                <span className="text-sm font-medium text-gray-800">
                                  {tramo.origen} → {tramo.destino}
                                </span>
                                {tramo.horaSalida && tramo.horaLlegada && (
                                  <span className="text-xs text-gray-400">
                                    {tramo.fechaSalida && tramo.fechaLlegada && 
                                     tramo.fechaSalida.split('T')[0] !== tramo.fechaLlegada.split('T')[0]
                                      ? `${formatearFechaCorta(tramo.fechaSalida)} ${tramo.horaSalida} → ${formatearFechaCorta(tramo.fechaLlegada)} ${tramo.horaLlegada}`
                                      : `${tramo.horaSalida} - ${tramo.horaLlegada}`
                                    }
                                  </span>
                                )}
                                {tramo.duracion && (
                                  <span className="text-xs text-pink-600 font-medium">
                                    {tramo.duracion}
                                  </span>
                                )}
                              </div>
                              <span className="text-sm font-bold text-[#e83e8c]">
                                ${formatPrecio(tramo.precio)}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="border-t border-gray-100 p-5 bg-white">
                  <button 
                    onClick={() => handleComprar(servicio)} 
                    className="w-full bg-[#e83e8c] hover:bg-[#c2185b] text-white py-3.5 rounded-xl text-sm font-medium flex items-center justify-center gap-3 transition-all duration-300 hover:gap-4 shadow-md hover:shadow-lg group"
                  >
                    <span>Comprar pasajes</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showEditModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-800">Editar búsqueda</h3>
              <button onClick={() => setShowEditModal(false)} className="p-1 text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <form onSubmit={handleEditSubmit} className="p-5 space-y-4">
              <div className="relative">
                <label className="block text-xs font-semibold text-gray-600 mb-1">Origen</label>
                <input 
                  type="text" 
                  value={editFormData.origen} 
                  onChange={handleOrigenChange}
                  onFocus={() => editFormData.origen && setShowOrigenSugerencias(true)}
                  onBlur={() => setTimeout(() => setShowOrigenSugerencias(false), 200)}
                  placeholder="Ciudad de origen"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                  required 
                  autoComplete="off"
                />
                {showOrigenSugerencias && origenSugerencias.length > 0 && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                    {origenSugerencias.map((ciudad) => (
                      <div
                        key={ciudad.id}
                        onClick={() => seleccionarOrigen(ciudad)}
                        className="px-3 py-2 hover:bg-pink-50 cursor-pointer border-b border-gray-100 last:border-0"
                      >
                        <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                        <div className="text-xs text-gray-500">{ciudad.estado}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block text-xs font-semibold text-gray-600 mb-1">Destino</label>
                <input 
                  type="text" 
                  value={editFormData.destino} 
                  onChange={handleDestinoChange}
                  onFocus={() => editFormData.destino && setShowDestinoSugerencias(true)}
                  onBlur={() => setTimeout(() => setShowDestinoSugerencias(false), 200)}
                  placeholder="Ciudad de destino"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                  required 
                  autoComplete="off"
                />
                {showDestinoSugerencias && destinoSugerencias.length > 0 && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                    {destinoSugerencias.map((ciudad) => (
                      <div
                        key={ciudad.id}
                        onClick={() => seleccionarDestino(ciudad)}
                        className="px-3 py-2 hover:bg-pink-50 cursor-pointer border-b border-gray-100 last:border-0"
                      >
                        <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                        <div className="text-xs text-gray-500">{ciudad.estado}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha de ida</label>
                <input 
                  type="date" 
                  min={getTodayDate()}
                  value={editFormData.fechaIda} 
                  onChange={(e) => setEditFormData({...editFormData, fechaIda: e.target.value})} 
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                  required 
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Pasajeros</label>
                <select value={editFormData.pasajeros} onChange={(e) => setEditFormData({...editFormData, pasajeros: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none">
                  {[1,2,3,4,5,6].map(num => <option key={num} value={num}>{num} {num === 1 ? 'pasajero' : 'pasajeros'}</option>)}
                </select>
              </div>

              <div className="flex gap-3 pt-4">
                <button type="button" onClick={() => setShowEditModal(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
                  Cancelar
                </button>
                <button type="submit" className="flex-1 px-4 py-2 bg-[#e83e8c] hover:bg-[#c2185b] text-white rounded-lg flex items-center justify-center gap-2">
                  <Search className="w-4 h-4" />
                  Buscar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </PublicLayout>
  );
};

export default Servicios;